<script setup>
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { ref, onMounted, computed, watch, nextTick, onBeforeUnmount } from 'vue';
import {useRoute, useRouter} from 'vue-router';
const router = useRouter();
import { getTranslation } from "../src/js/helpers/translations";
const swiperInstances = ref([]);
let properties = ref({});
let initial = ref(false);
let loading = ref(false);

const translations = getTranslation(getLangCode);

const favorites = JSON.parse(localStorage.getItem('favorites')) ?? [];

const toggleFavorite = (property, id) => {
    console.log('property', property);
    console.log('property', id);
    const index = favorites.indexOf(id);

    if (index === -1) {
        favorites.push(id);
    } else {
        favorites.splice(index, 1);
    }

    localStorage.setItem('favorites', JSON.stringify(favorites));
    
    if (localStorage.getItem('favorites') !== null) {
        const storage = JSON.parse(localStorage.getItem('favorites'));
        if (storage.includes(id)) {
            property.favorite = true;
        } else {
            property.favorite = false;
        }
    }
};

const checkIfFavorite = () => {
    if (localStorage.getItem('favorites') !== null) {
        properties.value.posts.forEach((property) => {
            const id = property.id;
            const favorites = JSON.parse(localStorage.getItem('favorites'));
            return property.favorite = favorites.includes(id);
        })
    }
};

async function fetchData() {
    if (localStorage.getItem('favorites') === null) {
        loading.value = false;
        return;
    }
    try {
        loading.value = true;
        let url = new URL(MyScriptVars.rest_url + 'favorites?properties=' + localStorage.getItem('favorites').replace(/[\[\]']+/g, ''));

        const propertiesResponse = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: new Headers({
                'X-WP-Nonce': MyScriptVars.nonce
            })
        });
        if (!propertiesResponse.ok) throw new Error('Network response was not ok for properties');
        properties.value = await propertiesResponse.json();
        loading.value = false;

    } catch (error) {
        console.error('Fetch operation failed:', error);
    }
}

const getPropertyPermalink = (property) => {
    if (!property) return '';
    if (getLangCode == 'de') return property.permalink_de;
    if (getLangCode == 'hr') return property.permalink_hr;
    if (getLangCode == 'cs') return property.permalink_cs;
    if (getLangCode == 'es') return property.permalink_es;
    if (getLangCode == 'fr') return property.permalink_fr;
    if (getLangCode == 'sl') return property.permalink_sl;
    if (getLangCode == 'hu') return property.permalink_hu;
    if (getLangCode == 'pl') return property.permalink_pl;
    if (getLangCode == 'fi') return property.permalink_fi;
    if (getLangCode == 'no') return property.permalink_no;
    if (getLangCode == 'sv') return property.permalink_sv;
    if (getLangCode == 'sk') return property.permalink_sk;
    if (getLangCode == 'it') return property.permalink_it;
    if (getLangCode == 'uk') return property.permalink_uk;
    if (getLangCode == 'nl') return property.permalink_nl;
    return property.permalink;
}

const getPropertyTitle = (property) => {
    if (!property) return '';
    if (getLangCode == 'de') return property.title_de;
    if (getLangCode == 'hr') return property.title_hr;
    if (getLangCode == 'cs') return property.title_cs;
    if (getLangCode == 'es') return property.title_es;
    if (getLangCode == 'fr') return property.title_fr;
    if (getLangCode == 'sl') return property.title_sl;
    if (getLangCode == 'hu') return property.title_hu;
    if (getLangCode == 'pl') return property.title_pl;
    if (getLangCode == 'fi') return property.title_fi;
    if (getLangCode == 'no') return property.title_no;
    if (getLangCode == 'sv') return property.title_sv;
    if (getLangCode == 'sk') return property.title_sk;
    if (getLangCode == 'it') return property.title_it;
    if (getLangCode == 'uk') return property.title_nl;
    if (getLangCode == 'nl') return property.title_nl;
    return property.title;
}

const initSwipers = () => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];

    nextTick(() => {
        const swiperElements = document.querySelectorAll('.swiper-property');
        swiperElements.forEach(el => {
            const swiper = new Swiper(el, {
                modules: [Navigation],
                speed: 600,
                slidesPerView: 1,
                lazy: true,
                preloadImages: false,
                spaceBetween: 0,
                navigation: {
                    prevEl: el.querySelector('.swiper-button-prev'),
                    nextEl: el.querySelector('.swiper-button-next')
                }
            });
            swiperInstances.value.push(swiper);
        });
    });
}

const setWidth = () => {
    const overflowText = document.querySelectorAll('.overflow-calc');

    overflowText.forEach(text => {
        const width = text.parentElement.offsetWidth;
        text.style.maxWidth = `${width - 1}px`;
        text.style.whiteSpace = 'nowrap';
    });
}

onMounted(async () => {
    await nextTick();
    setTimeout(async () => {
        await fetchData();
        initial.value = true;
        initSwipers();
        setWidth();
        window.addEventListener('resize', setWidth);
        checkIfFavorite();
    }, 500)
});

onBeforeUnmount(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    window.removeEventListener('resize', setWidth);
});
</script>

<template>
    <section class="property-list-section">
        <div class="container-properties">
            <div class="property-list-intro m-40">
                <h1 class="section-title">
                    Favorites
                </h1>
            </div>
            <div id="properties-scroll">
                <div v-if="loading" class="loader-wrap">
                    <div class="loader"></div>
                </div>
                <div v-else-if="properties.posts && properties.posts.length > 0" class="property-list-grid grid m-30" data-function="overflowCalculate">
                    <div v-for="property in properties.posts" class="property-item">
                        <div
                            class="favorite-btn"
                            :class="{'active': property.favorite }"
                            @click.prevent="toggleFavorite(property, property.id)"
                        >
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 471.701 471.701" xml:space="preserve">
                                <path d="M433.601,67.001c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7,13.6-92.4,38.3l-12.9,12.9l-13.1-13.1 c-24.7-24.7-57.6-38.4-92.5-38.4c-34.8,0-67.6,13.6-92.2,38.2c-24.7,24.7-38.3,57.5-38.2,92.4c0,34.9,13.7,67.6,38.4,92.3 l187.8,187.8c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-3.9l188.2-187.5c24.7-24.7,38.3-57.5,38.3-92.4 C471.801,124.501,458.301,91.701,433.601,67.001z M414.401,232.701l-178.7,178l-178.3-178.3c-19.6-19.6-30.4-45.6-30.4-73.3 s10.7-53.7,30.3-73.2c19.5-19.5,45.5-30.3,73.1-30.3c27.7,0,53.8,10.8,73.4,30.4l22.6,22.6c5.3,5.3,13.8,5.3,19.1,0l22.4-22.4 c19.6-19.6,45.7-30.4,73.3-30.4c27.6,0,53.6,10.8,73.2,30.3c19.6,19.6,30.3,45.6,30.3,73.3 C444.801,187.101,434.001,213.101,414.401,232.701z"/>
                            </svg>
                        </div>
                        <a :href="property.youtube" v-if="property.youtube" target="_blank"  class="video-link">
                            <img src="https://croatiarealestates.com/wp-content/uploads/2024/04/video-camera.png"/>
                        </a>
                        <a :href="getPropertyPermalink(property)" class="block">
                            <div class="property-item-slider m-15" id="property-item-slider" data-function="propertyItemSlider">
                                <div class="swiper swiper-property" ref="setSwiper">
                                    <div class="swiper-wrapper">
                                        <div v-for="(image, index) in property.gallery" class="swiper-slide">
                                            <div class="slide-inner relative overflow">
                                                <template v-if="index === 0">
                                                    <img :src="image.url" class="object-fit-cover" :alt="image.title">
                                                </template>
                                                <template v-else>
                                                    <img :src="image.url" class="object-fit-cover" :alt="image.title" loading="lazy">
                                                    <div class="swiper-lazy-preloader"></div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-button-prev"></div>
                                    <div class="swiper-button-next"></div>
                                </div>
                            </div>
                            <p class="list-card-price text-8 color-1 medium">
                                € {{ property.price }}
                            </p>
                            <p class="list-card-location text-1 color-1 overflow-calc">
                                {{ getPropertyTitle(property) }}
                            </p>
                            <p class="list-card-info text-1 color-3 overflow-calc">
                            <span>
                                {{ property.bedrooms }} {{ translations.bedrooms }}
                            </span>
                                <span>
                                {{ property.bathrooms }} {{ translations.bathrooms }}
                            </span>
                                <span>
                                {{ property.size }} ㎡
                            </span>
                            </p>
                        </a>
                    </div>
                </div>
                <div v-else class="no-properties">
                    <h2>No favorites found</h2>
                </div>
            </div>
        </div>
    </section>
</template>